<!--  -->
<template>
    <div :style="paddingLeft" class="nav-item" :class="{active: isActive,vertical}" @click="onClick" :data-name="name">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'g-nav-item',
    props: {
        name: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isActive: false,
            index:0
        }
    },
    inject: ['eventBus','vertical'],
    mounted() {
        this.eventBus && this.eventBus.$on('mountedSelect', value => {
            this.isActive = value === this.name
        })
        if(this.$parent.$options.name === 'g-sub-nav'){
            this.eventBus && this.$nextTick(()=>{
                this.index = this.$parent.index +1
            })
            
            
        }
    },
    methods: {
        onClick() {
            this.eventBus && this.eventBus.$emit('navItemClick', this.name)
        }
    },
    computed: {
        paddingLeft(){
            return {
                'padding-left': `${this.index *10 + 20}px`
            }
        }
    }
}
</script>
<style scoped lang='scss'>
@import '../var';
.nav-item {
    padding: 10px 20px;
    box-sizing: border-box;
    cursor: pointer;
    font-size:$font-size;
    &:not(.vertical){
        &.active {
        position: relative;
        &::after{
            content:'';
            position:absolute;
            bottom:0;
            left:0;
            width:100%;
            border-bottom:2px solid $blue;
        }
    }
    }
    
    &:hover{
        color:#000;
    }
    &.vertical{
        &.active{
            background:$baby-blue;
            color:$blue !important;
        }
        &:hover{
            background:$baby-blue;
            color:$blue !important;
        }
    }
}
.sub-nav .nav-item{
    &.active{
        color:#000;
        &::after{
            border:none;
        }
        &:hover{
            color:#000;
        }
    }
}
</style>